module.exports = __webpack_public_path__ + "img/jiankonglan.e59760e1.png";